<template>
  <div class="index-content">
    <!-- 轮播图 -->
    <el-carousel
      :interval="5000"
      arrow="always"
      indicator-position="outside"
      height="500px"
      class="carousel-bg"
    >
      <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
        <div class="carousel-content">
          <img :src="item.image" alt="Carousel Image" class="carousel-image" />
          <div class="carousel-text">
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 标题和描述文本模块 -->
    <section class="title-description-section">
      <el-row type="flex" justify="center" align="middle">
        <el-col :span="24" class="content-container">
          <h2>{{ titleDescription.title }}</h2>
          <p v-html="titleDescription.description"></p>
        </el-col>
      </el-row>
    </section>

    <!-- 介绍模块 -->
    <section
      class="feature-section"
      v-for="(feature, idx) in features"
      :key="idx"
    >
      <el-row type="flex" justify="center" align="middle">
        <el-col
          :span="isMobile || feature.imagePosition === 'left' ? 24 : 12"
          :class="[
            'feature-image',
            feature.imagePosition === 'left'
              ? 'feature-image-left'
              : 'feature-image-right',
          ]"
        >
          <img :src="feature.image" alt="Feature Image" class="feature-image" />
        </el-col>
        <br />
        <el-col :span="isMobile ? 24 : 12" class="feature-description">
          <div class="description-container">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
            <!-- <el-button type="primary" @click="handleButtonClick(feature)"
              >Learn More</el-button
            >
            <a
              :href="feature.downloadLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                :src="feature.downloadImg"
                alt="Download on Google Play"
                class="google-play-icon"
              />
            </a> -->
          </div>
        </el-col>
      </el-row>
    </section>

    <!-- 游戏视频模块 -->
    <!-- <section class="video-section">
      <el-row type="flex" justify="center" align="middle">
        <el-col :span="20">
          <div class="video-container">
            <h2 class="video-title">{{ videoTitle }}</h2>
            <video controls class="game-video">
              <source :src="videoSrc" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </el-col>
      </el-row>
    </section> -->

    <!-- 标题和居中图片模块 -->
    <section class="centered-title-image-section">
      <el-row type="flex" justify="center" align="middle">
        <el-col :span="24" class="content-container">
          <h2>{{ centeredImage.title }}</h2>
          <img
            :src="centeredImage.imageSrc"
            :alt="centeredImage.imageAlt"
            class="centered-image"
          />
        </el-col>
      </el-row>
    </section>




     <!-- 标题和描述文本模块 -->
    <section class="title-description-section">
      <el-row type="flex" justify="center" align="middle">
        <el-col :span="24" class="content-container">
          <h2>Product Introduction</h2>
          <p><strong>Game Rules:</strong> Control the driver to move the motorcycle, crossing obstacles. The early stages are relatively easy, but the difficulty increases with each subsequent stage. Winning condition is successfully completing all stages without flipping over.</p>
        <p><strong>Failure Rule:</strong> Flipping over during a stage results in challenge failure.</p>
        <p><strong>Success Rule:</strong> Successfully completing all stages without flipping over results in victory.</p>
        </el-col>
      </el-row>
    </section>


    <section class="title-description-section">
      <el-row type="flex" justify="center" align="middle">
        <el-col :span="24" class="content-container">
          <h2>Game Features Overview</h2>
          <table border="1" cellpadding="10" cellspacing="0">
          <tr>
            <th>System</th>
            <th>Description</th>
          </tr>
          <tr>
            <td>Storyline</td>
            <td>40 stages, each progressively more difficult.</td>
          </tr>
          <tr>
            <td>Bike (BLKE)</td>
            <td>3 types of motorcycles, additional bikes can be purchased with enough coins.</td>
          </tr>
          <tr>
            <td>Upgrade</td>
            <td>With sufficient coins, you can enhance bike stability.</td>
          </tr>
          <tr>
            <td>Coins</td>
            <td>Earned at the end of each game based on performance.</td>
          </tr>
        </table>
        </el-col>
      </el-row>
    </section>

  
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false, // 初始化为false
      isMenuCollapsed: true, // 默认关闭菜单
      isFixedTop: false, // 控制是否固定在顶部
      scrollThreshold: 100, // 滚动阈值，单位为像素
      carouselItems: [
        {
          image: require("@/assets/img/20250324185059.png"),
          title: "Extreme Motocross",
          description:
            "Extreme Motocross takes you into a challenging world full of steep hills and thrilling jumps. With its advanced 3D rendering technology, this game not only presents detailed and realistic motorcycle models, but also allows players to experience the realism of riding on various complex terrains. Whether it is crossing muddy trails at high speed or jumping from a high altitude, Extreme Motocross provides an unprecedented exciting experience.",
        },
        // {
        //   image: require("@/assets/img/wallhaven-3lv8j6.jpg"),
        //   title: "Title 2",
        //   description: "Description for the second slide.",
        // },
        // 添加更多轮播图项
      ],
      features: [
        {
          image: require("@/assets/img/20250324185203.png"),
          title: "Diverse Environment",
          description:
            "We provide 40 game tracks, which can not only meet the needs of different types of players, but also ensure that every game experience is full of freshness and challenges. Whether you are a passionate racing enthusiast seeking speed and passion, or an adventurer who likes to explore and discover new things, there are tracks suitable for you waiting to be conquered.",
          downloadLink: "#", // 替换为实际的下载链接
          downloadImg: require("@/assets/img/google-play-badge.png"),
          imagePosition: "left", // 控制图片位置：'left' 或 'right'
        },
        {
          image: require("@/assets/img/20250324185334.png"),
          title: "YOUR TIME IS NOW!",
          description:
            "Experience high-octane off-road motorcycling with new riding modes - every move brings new surprises and challenges your riding style in new ways.",
          downloadLink: "#", // 替换为实际的下载链接
          downloadImg: require("@/assets/img/google-play-badge.png"),
          imagePosition: "right", // 控制图片位置：'left' 或 'right'
        },

        // 添加更多特征模块
      ],
      titleDescription: {
        title: "Challenge your limits and pursue excitement",
        description:
          "Welcome to the world of extreme motocross! Here you will experience unprecedented excitement and challenges. We have carefully designed various types of tracks, from treacherous mountain trails to muddy forest roads, where every turn and incline tests your driving skills. Control the gas and brakes precisely, keep your front and rear balance, and avoid flipping your car in the complicated terrain. Whether you are a novice or a veteran, Extreme Motocross will bring you endless fun and fulfillment.",
      },
      centeredImage: {
        title: "Beautiful motorcycle design",
        imageSrc: require("@/assets/img/20250324185121.png"), // 添加实际图片路径
        imageAlt: "Champion Image",
      },
      videoTitle: "Watch Our Game in Action!", // 视频标题
      videoSrc: require("@/assets/img/app_base_63539443852c445e8682b27a3b0b662e_19.png"), // 视频源文件路径
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleScroll() {
      this.isFixedTop = window.scrollY > this.scrollThreshold;
    },
    handleButtonClick(feature) {
      console.log(`Button clicked for feature: ${feature.title}`);
    },
  },
};
</script>

<style scoped>
/* 全局样式 */
.index-content {
  padding: 10px;
}

/* 轮播图部分 */
.carousel-bg {
  margin-bottom: 40px;
  overflow: hidden; /* 移除可能的滚动条 */
}

.carousel-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-text {
  position: absolute;
  bottom: 30px;
  left: 30px;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* 文字阴影提高可见性 */
}

@media only screen and (max-width: 768px) {
  .el-carousel__item h3 {
    font-size: 18px;
  }

  .carousel-bg {
    height: 300px !important; /* 强制设置高度 */
  }

  .el-carousel__container {
    overflow: hidden !important; /* 确保没有滚动条 */
  }
}





/* 标题和描述文本模块样式 */
.title-description-section {
  margin-bottom: 40px;
  padding: 20px;
  text-align: center;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
}

/* 标题和居中图片模块样式 */
.centered-title-image-section {
  margin-bottom: 40px;
  padding: 20px;
  text-align: center;
}

.centered-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
}

/* 特色模块 */
.feature-section {
  margin-bottom: 40px;
}

.feature-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.description-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* 居中对齐所有内容 */
  padding: 20px;
}

.description-container > * {
  margin-bottom: 15px; /* 给每个直接子元素添加一些底部间距 */
}

.description-container > *:last-child {
  margin-bottom: 0; /* 移除最后一个元素的底部间距 */
}

.google-play-icon {
  max-width: 150px;
  width: 100%;
}

/* 新增的游戏视频模块样式 */
.video-section {
  margin-bottom: 40px;
  padding: 20px;
}

.video-container {
  position: relative;
  text-align: center;
}

.video-title {
  font-size: 24px;
  margin-bottom: 10px;
}

.game-video {
  width: 100%;
  max-height: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

@media only screen and (min-width: 768px) {
  .feature-description {
    text-align: left;
  }

  .description-container {
    align-items: flex-start; /* 左对齐所有内容 */
  }

  .description-container > * {
    margin-bottom: 20px; /* 可根据需要调整 */
  }

  .feature-image-left {
    order: 1;
  }

  .feature-image-right {
    order: 3;
  }

  .feature-description {
    order: 2;
  }

  .el-col {
    margin-top: 0;
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 768px) {
  .feature-section,
  .video-section {
    flex-direction: column;
  }

  .el-row {
    flex-wrap: wrap; /* 允许在小屏幕上换行 */
  }

  .feature-image-left,
  .feature-image-right {
    order: 1; /* 在小屏幕上始终先显示图片 */
    width: 100%;
    margin-top: 0;
    margin-bottom: 20px; /* 增加上下间距 */
  }

  .feature-description {
    order: 2; /* 在小屏幕上后显示描述 */
    width: 100%;
    margin-top: 0;
    margin-bottom: 20px; /* 增加上下间距 */
  }

  .game-video {
    max-height: 300px;
  }

  /* 确保图片和描述部分有足够空间 */
  .feature-section .el-col img {
    width: 100%;
    max-height: 300px;
    object-fit: cover;
  }

  .description-container {
    text-align: center;
  }

  /* 确保按钮在同一行上 */
  .description-container > * {
    margin-bottom: 10px;
  }

  .description-container a {
    display: block;
    width: 100%;
    text-align: center;
  }

  .google-play-icon {
    width: 100%;
    max-width: 150px;
    margin: 0 auto;
  }
  table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
  text-align: left;
}
}
</style>


// WEBPACK FOOTER //
// src/components/views/pages/Index.vue